import makeStyles from '@mui/styles/makeStyles';

const headerMenuStyles = makeStyles((theme) => {
    return {
        linkStyle: {
            padding: '15px',
            borderRadius: 'initial',
            color: 'inherit',
            textDecoration: 'unset',
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
                color: theme.palette.accent.light
            }
        },
        activeRoute: {
            textDecoration: 'underline',
            color: theme.palette.accent.light
        },
        menuPaddingOverride: {
            padding: '31px 14px 27px'
        }
    };
});

export default headerMenuStyles;
